<template>
  <v-card class="pa-4">
    <v-btn absolute top right text icon @click="$emit('close')">
      <v-icon color="grey">mdi-close</v-icon>
    </v-btn>

    <div class="my-6 text-center">
      <h3>Alienar múltiplos equipamentos</h3>
    </div>

    <v-form ref="form">
      <div>
        <label class="ml-1 text-caption">Motivo</label>
        <v-textarea
          v-model="reason"
          outlined
          dense
          class="primary-input"
          hide-details="auto"
          :rules="[(v) => !!v || 'Digite o motivo']"
          placeholder="Descreva aqui o motivo pelo qual os equipamentos serão alienados..."
        ></v-textarea>
      </div>

      <div>
        <label class="ml-1 text-caption">Data da alienação</label>
        <div class="d-flex">
          <date-picker
            ref="datepicker"
            style="width: 100%"
            v-model="checklistStartDate"
            mode="date"
            :popover="{ visibility: 'click', positionFixed: 'true' }"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :class="
                  checklistStartDateError ? 'date-input-error' : 'date-input'
                "
                :value="inputValue"
                v-on="inputEvents"
                v-mask="['##/##/#### ##:##']"
                @focus="setLaborNowDate"
              />

              <span class="date-span-error" v-if="checklistStartDateError">
                {{ $t('Selecione a data da solicitação') }}
              </span>
            </template>
          </date-picker>
        </div>
      </div>
    </v-form>

    <div class="d-flex justify-end mt-4">
      <v-btn
        class="primary-button mr-0"
        depressed
        :loading="loading"
        @click="submit"
      >
        Salvar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../services/ApiService'

export default {
  name: 'AlienateMultipleDialog',

  props: {
    selectedEquipments: Array,
  },

  data() {
    return {
      checklistStartDate: null,
      checklistStartDateError: false,
      reason: '',
      date: '',
      apiService: new ApiService(),
      loading: false,
    }
  },
  watch: {
    checklistStartDate: {
      deep: true,
      handler() {
        this.checklistStartDateError = false
      },
    },
  },
  methods: {
    setLaborNowDate() {
      this.checklistStartDate = !this.checklistStartDate
        ? null
        : this.checklistStartDate
    },
    save(date) {
      this.date = this.formatDate(this.checklistStartDate)
      this.$refs.menuStartDate.save(date)
    },
    submit() {
      if (
        !this.$refs.form.validate() ||
        this.checklistStartDate == null ||
        this.checklistStartDate == ''
      ) {
        if (this.checklistStartDate == null || this.checklistStartDate == '') {
          this.checklistStartDateError = true
          return
        }
        return
      }

      this.loading = true

      const model = {
        alienateDate: this.checklistStartDate,
        reason: this.reason,
        equipmentIds: this.selectedEquipments.map((x) => x.id),
      }

      this.apiService
        .post('equipment/alienate/multiple', model)
        .then(() => {
          this.loading = false
          this.$toast.success('Os equipamentos selecionados foram alienados!')
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/yyyy') : ''
    },
  },
}
</script>

<style scoped>
.date-input {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 1px solid #707070 !important;
  padding-left: 10px !important;
}

.date-input-error {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 2px solid #ff5252 !important;
  padding-top: 0 !important;
}
</style>
